<template>
  <div>
    <div class="block_input">

      <div class="Attribute"> Name</div>
      <div class="Attribute_info"> Name of the device</div>
      <el-input v-model="device.name"></el-input>

    </div>

    <div class="block_input">

      <div class="Attribute"> Description</div>
      <div class="Attribute_info"> Device description</div>
      <el-input v-model="device.description" type="textarea"></el-input>

    </div>

    <div v-if="type_device" class="block_input">

      <div class="Attribute"> Cron schedule for updates</div>
      <div class="Attribute_info"> The rate in which the gateway will be sending the updates. <a
        href="https://en.wikipedia.org/wiki/Cron" target="_blank"><i class="el-icon-info"></i></a></div>
      <el-input v-model="device.send_update_cron"></el-input>

    </div>
    <div v-if="type_device" class="block_input">

      <div class="Attribute"> Update interval</div>
      <div class="Attribute_info"> The interval in which the gateway will be sending the updates. </div>
      <el-input v-model.number="device.send_update_interval"></el-input>

    </div>
    <div class="block_input">

      <div class="Attribute"> uid</div>

      <div class="Attribute_info"> A unique identifier that will be assigned to the device.</div>

      <el-input v-model="device.id" :type="showUID ?'text' :'password'" :disabled="true">

        <el-button slot="append" @click="toggleShowUID">{{showUID?'Hide':'Show'}}</el-button>

      </el-input>

    </div>

    <div v-if="type_device" class="block_input">

      <div class="Attribute"> Token</div>
      <div class="Attribute_info"> Access token for the device to access the cloud.</div>

      <el-input v-model="device.token" :type="showToken?'text' :'password'" :disabled="true">
        <el-button slot="append" @click="toggleShowToken">{{showToken?'Hide':'Show'}}</el-button>
      </el-input>
    </div>

    <el-switch
      v-if="type_device"
      @change="toggleComms"
      v-model="device.is_comms_local"
      active-text="Local Comms"
      inactive-text="Global Comms" :disabled="!currentUser|| (currentUser&&currentUser.comms===undefined) || (currentUser.comms && currentUser.comms==={})">
    </el-switch>
    <div v-if="type_device && device.is_comms_local">
      <el-radio-group v-model="device.connection_type" @change="setComms()">
        <el-radio label="ethernet">Ethernet</el-radio>
        <el-radio label="satcom">Satcom</el-radio>
        <el-radio label="nbiot">NBIoT</el-radio>
      </el-radio-group>
      <nbiot ref="nbiot_data" v-show="device.connection_type==='nbiot'" @closeDialog="outerVisible = false" />
      <!-- <lora ref="lora_data" v-show="device.connection_type==='lora'" @closeDialog="outerVisible = false" />
  <gprs ref="gprs_data" v-show="device.connection_type==='gprs'" @closeDialog="outerVisible = false" /> -->
      <ethernet ref="ethernet_data" v-show="device.connection_type==='ethernet'" @closeDialog="outerVisible = false" />
      <satcom ref="satcom_data" v-show="device.connection_type==='satcom'" @closeDialog="outerVisible = false" />
    </div>

  </div>
</template>

<script>
import Token from "../../../../Class/Token";
import nbiot from "../../../layout/components/profile/configuration/nbiot";
import lora from "../../../layout/components/profile/configuration/lora";
import gprs from "../../../layout/components/profile/configuration/gprs";
import ethernet from "../../../layout/components/profile/configuration/ethernet";
import satcom from "../../../layout/components/profile/configuration/satcom";
import { mapGetters } from "vuex";

const uuidv4 = require("uuid/v4");
export default {
  data() {
    return {
      isGenerating: true,
      device: {
        connection_type: "ethernet",
        send_update_cron:"0 0 * * *",
        send_update_interval:1200,
        is_comms_local: true,
        comms: {}
      },
      showUID: false,
      showToken: false,
      formRules: {}
    };
  },
  components: {
    nbiot,
    ethernet,
    gprs,
    satcom,
    lora
  },
  name: "Gatwayinitform",

  props: {
    type_device: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: String,
      required: true
    }
  },
  created() {
    this.generateId();
    this.generateToken();
  },
  mounted() {
    this.setComms();
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  methods: {
    toggleComms(toggle) {
      if (toggle) {
        if (
          !this.currentUser.comms ||
          (this.currentUser.comms && this.currentUser.comms === {})
        ) {
          this.device.is_comms_local = true;
          return;
        }
        console.log("Current User", this.currentUser);

        this.device.comms = this.currentUser.comms;
      } else {
        this.setComms();
      }
    },
    setComms() {
      if (this.device.is_comms_local) {
        switch (this.device.connection_type) {
          case "ethernet":
            console.log("ETHERNET", this.$refs.ethernet_data.comms);
            this.device.comms = this.$refs.ethernet_data.comms;
            break;
          case "satcom":
            console.log("SATCOM", this.$refs.satcom_data.comms);

            this.device.comms = this.$refs.satcom_data.comms;
            this.device.satcom_config=this.$refs.satcom_data.satcom_config
            break;
          case "nbiot":
            console.log("NBIOT", this.$refs.nbiot_data.comms);

            this.device.comms = this.$refs.nbiot_data.comms;
            break;
          case "lora":
            console.log("LORA", this.$refs.lora_data.comms);

            this.device.comms = this.$refs.lora_data.comms;
            break;
          case "gprs":
            console.log("GPRS", this.$refs.gprs_data.comms);

            this.device.comms = this.$refs.gprs_data.comms;
            break;
        }
      }

      // return this.device.comms;
    },
    toggleShowUID() {
      this.showUID = !this.showUID;
    },

    toggleShowToken() {
      this.showToken = !this.showToken;
    },
    generateToken() {
      if (this.device.id && this.projectId) {
        this.device.token = window.btoa(this.device.id + ":" + this.projectId);
        console.log("token");
        console.log("[", this.device.token, "]");
      } else {
        alert("missing device id or the token");
      }
    },

    generateId() {
      this.device.id = uuidv4();
    }
  }
};
</script>

<style lang="scss" scoped>
.block_input {
  padding: 2%;
}

.Attribute {
  font-weight: bold;
  //  font-size: 1.2em;
}

.Attribute_info {
  padding: 1%;
  font-weight: bold;
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/newGateWay/subComponents/gatewayinitform.vue